var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFileicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#009ee0",
    strokeWidth: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.375.375h10.066l4.653 4.578v18.672a3 3 0 01-3 3H3.375a3 3 0 01-3-3V3.375a3 3 0 013-3zm1.102 8.367l9.843-.656m-9.843 6.562l9.843.657m-.164 5.414l-9.844.656m.165-9.68h5.906m-.164 6.071H4.312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.441.375c-.924 1.738-.828 3.116.286 4.134 1.115 1.017 2.571 1.171 4.368.46L13.441.375z"
  }))));
}

export default SvgFileicon;